import { render, staticRenderFns } from "./ManageClientsSelector.vue?vue&type=template&id=2ffce4c6"
import script from "./ManageClientsSelector.vue?vue&type=script&lang=js"
export * from "./ManageClientsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports